(function ($) {
	'use strict';

	var WEAPP = {

		init: function () {
			this.mainMenuBlock();
			this.submenuOpener();
			this.fixedHeader();
			this.sliderMain();
			this.newsMosaic();
			this.numberCounter();
			this.circularCursor();
		},



		mainMenuBlock: function () {
			jQuery('header').on('click', '.navbar-toggle-btn', function (e) {
				e.preventDefault();
				if (!jQuery(this).hasClass("nav-open")) {
					jQuery('#navbar').removeClass('active');
					jQuery('html').removeClass('menu-active');
					jQuery(this).removeClass('nav-close').addClass('nav-open');
					//         jQuery('header').removeClass('nav-close').addClass('nav-open');

				} else {
					jQuery('#navbar').addClass('active');
					jQuery('html').addClass('menu-active');
					jQuery(this).removeClass('nav-open').addClass('nav-close');
				}
			});
		},

		submenuOpener: function () {
			jQuery(".navbar-nav .submenu-opener").on('click', function (e) {
				// e.preventDefault();
				if (!jQuery(this).hasClass('closed')) {
					jQuery(this).addClass('closed');
					jQuery(this).next('ul.dropdown-menu').slideToggle();
				}
				else {
					jQuery(this).removeClass('closed');
					jQuery(this).next('ul.dropdown-menu').slideToggle();
				}

			});

		},

		

		fixedHeader: function () {
			jQuery(window).scroll(function () {
				var sticky = jQuery('header'),
					scroll = jQuery(window).scrollTop();

				if (scroll >= 30) sticky.addClass('sticky-header');
				else sticky.removeClass('sticky-header');
			});
		},

		sliderMain: function () {
			var $status = $('.pagingInfo');
			var $slickElement = $('.slideshow');

			$slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
				//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
				var i = (currentSlide ? currentSlide : 0) + 1;
				$status.text(i + '/' + slick.slideCount);
			});

			$slickElement.slick({
				autoplay: false,
				dots: false,
				arrows: true,
				fade: true,
				adaptiveHeight: true,
				responsive: [
					{
					  breakpoint: 992,
					  settings: {
						slidesToShow: 1.2,
						arrows: false,
						fade: false,
						infinite: false
					  }
					},
					
				  ]
			});
		},

		newsMosaic: function () {
			/**
* Elastic Columns demo page
*/
			function ElasticColumnsDemo() {
				this.init();
			};

			/**
			 * Inits the page
			 */
			ElasticColumnsDemo.prototype.init = function () {
				// DOM
				this.$container = $('.news-content');
				this.$loader = $('.loader');

				// Creates and displays the grid
				this.$container.elasticColumns(
					{
						columns: this.getColumnsCount(),
						innerMargin: 30,
						outerMargin: 0

					});
				this.displayItems();

				// Resize event: tell the plugin to refresh the layout
				$(window).on('resize', $.proxy(this, 'onResize'));


			};

			/**
			 * Adds random items
			 * @param evt
			 */
			ElasticColumnsDemo.prototype.onAddRandomItems = function (evt) {
				evt.preventDefault();
				this.$loader.css('visibility', 'visible');

				// Builds a random array
				var items = this.$container.children(':not(.elastic-columns-ignore)').get();
				for (var index = items.length - 1; index > 0; index -= 1) {
					var random_index = Math.floor(Math.random() * (index + 1));
					items[index] = items[random_index];
					items[random_index] = items[index];
				}
				items = items.slice(0, 3);

				// Adds the items to the container
				for (index = 0; index < items.length; index += 1) {
					var $new_item = $(items[index]).clone().hide();
					this.$container.append($new_item);
				}

				// Refresh the grid and show the items, when the content has been loaded
				var $images = this.$container.children(':hidden').find('img');
				if ($images.length > 0) {
					$images.on('load', $.proxy(this, 'onNewContentLoaded'));
					$images.on('error', $.proxy(this, 'onNewContentLoaded'));
				}
				else {
					this.onNewContentLoaded();
				}
			};

			/**
			 * Displays new content when it has been loaded
			 */
			ElasticColumnsDemo.prototype.onNewContentLoaded = function () {
				this.$container.elasticColumns('refresh');
				this.displayItems();
			};

			/**
			 * Randomly reorder items
			 * @param evt
			 */
			ElasticColumnsDemo.prototype.onRandomlyReorderItems = function (evt) {
				evt.preventDefault();
				var items = this.$container.children(':not(.elastic-columns-ignore)').get();
				for (var index = 0; index < items.length - 1; index += 1) {
					var random_index = Math.floor(Math.random() * index);
					this.$container.append($(items[random_index]));
				}
				this.$container.elasticColumns('refresh');
			};

			/**
			 * Returns the number of columns depending on the container width
			 */
			ElasticColumnsDemo.prototype.getColumnsCount = function () {
				var grid_width = $('.news-content').width();
				var column_width = grid_width;
				var columns = 1;
				while (column_width > 700) {
					columns += 1;
					column_width = grid_width / columns;
				}
				
				return columns;
			};

			/**
			 * Resizes the window
			 */
			ElasticColumnsDemo.prototype.onResize = function () {
				this.$container.elasticColumns('set', 'columns', this.getColumnsCount());
				this.$container.elasticColumns('refresh');
			};

			/**
			 * Displays the hidden grid items
			 */
			ElasticColumnsDemo.prototype.displayItems = function () {
				var delay = 0;
				this.$container.children(':hidden:not(.elastic-columns-ignore)').each(function () {
					$(this).delay(delay).fadeIn(300);
					delay += 150;
				});
				this.$loader.delay(delay).css('visibility', 'hidden');
			};


			window.onload = function () {
				new ElasticColumnsDemo();
			};
		},






		numberCounter: function () {


			const easeInOutQuad = (t) => t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

			const inViewportCounter = (el) => {

				const duration = +el.dataset.duration || 3000;
				const start = +el.textContent || 0;
				const end = +el.dataset.count || 100;
				let raf;


				const counterStart = () => {
					if (start === end) return; // If equal values, stop here.

					const range = end - start;
					let curr = start; // Set current to start
					const timeStart = Date.now();

					const loop = () => {
						let elaps = Date.now() - timeStart;
						if (elaps > duration) elaps = duration;
						const frac = easeInOutQuad(elaps / duration); // Get the time fraction with easing
						const step = frac * range; // Calculate the value step
						curr = start + step; // Increment or Decrement current value
						el.textContent = Math.trunc(curr); // Apply to UI as integer
						if (elaps < duration) raf = requestAnimationFrame(loop); // Loop
					};

					raf = requestAnimationFrame(loop); // Start the loop!
				};

				const counterStop = (el) => {
					cancelAnimationFrame(raf);
					el.textContent = start;
				};


				const inViewport = (entries, observer) => {
					entries.forEach(entry => {
						// Enters viewport:
						if (entry.isIntersecting) counterStart(entry.target);
						// Exits viewport:
						else counterStop(entry.target);
					});
				};
				const Obs = new IntersectionObserver(inViewport);
				const obsOptions = {};
				Obs.observe(el, obsOptions);
			};

			document.querySelectorAll('[data-count]').forEach(inViewportCounter);
		},

		circularCursor: function () {
			$(document).ready(function() {
				$(document).on('mousemove', function(e) {
				  $('#circularcursor').css({
					left: e.pageX,
					top: e.pageY
				  });
				});
				
				  $('.next-project-wrapper').hover(function(){
					$('#circularcursor').addClass("visible");
				  }, function(){
					$('#circularcursor').removeClass("visible");
				  });
			  });

		},

		




	};

	WEAPP.init();

})(jQuery);




